const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: "none!important"
  }),
  thead: {
    position: "sticky"
  },
  tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "left"
  },
  tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tableheaderlast: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tablecontent: {
    color: "black",
    fontSize: "11pt",
    textAlign: "center"
  },
  tablecontent_first: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "11pt",
    textAlign: "left"
  },
  tablecontentlast: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "12pt"
  },
  failState: {
    color: theme.palette.fail
  },
  passState: {
    color: theme.palette.success
  },
  div_table1: {
    paddingTop: 30,
    height: 380,
    overflow: "auto"
  },
  div_table2: {
    height: 300,
    overflow: "auto"
  },
  table_body: {
    maxHeight: 300,
    overflow: "auto"
  },
  defaultText: {
    fontSize: "14px"
  },
  passedText: {
    color: "#4CAF50",
    fontSize: "14px"
  },
  failedText: {
    color: "#FF5252",
    fontSize: "14px"
  },
  totalGrid: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center"
  },
  totalGridLast: {
    textAlign: "center"
  },
  infoHead: {
    display: "flex",
    margin: "0 Auto",
    width: "80px"
  },
  pass: {
    margin: theme.spacing.unit,
    textAlign: "center"
  },
  table2: {
    overflow: "auto",
    height: 380
  },
  infoText: {
    paddingTop: "2px",
    paddingLeft: "3px",
    whiteSpace: "nowrap"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/results/views/traceroute/styles.js